const PLACEHOLDER_ORIGIN = 'http://placeholder.invalid';

/**
 * Accept a `from` redirect target only when it is a same-origin app path.
 * Rejects absolute URLs, protocol-relative `//host`, backslashes (browsers
 * treat `/\host` as `//host`) and anything that resolves off-origin once the
 * URL parser strips tabs/newlines. Returns the normalized path, or null.
 */
export const getSafeRedirectPath = (
  from: string | null | undefined,
): string | null => {
  if (
    !from ||
    !from.startsWith('/') ||
    from.startsWith('//') ||
    from.includes('\\')
  ) {
    return null;
  }

  try {
    const url = new URL(from, PLACEHOLDER_ORIGIN);

    if (url.origin !== PLACEHOLDER_ORIGIN) {
      return null;
    }

    const path = `${url.pathname}${url.search}${url.hash}`;

    // Dot segments can normalize into a protocol-relative path, e.g.
    // `/.//evil.com` → `//evil.com`, so re-check the result.
    if (path.startsWith('//') || path.includes('\\')) {
      return null;
    }

    return path;
  } catch {
    return null;
  }
};
